import { Route } from "react-router-dom";
import {
  Home,
  Dashboard,
  WalletFiat,
  WalletCrypto,
  Utilities,
  Transactions,
  Settings,
  Rates,
  SuccessTransaction,
  DownloadApp,
  Notifications,
} from "../pages";
import { UserIsAuthenticated } from "./AuthProvider";

const PrivateRoutes = (
  <Route>
    {[
      { path: "/", element: Home },
      { path: "/dashboard", element: Dashboard },
      { path: "/wallets-fiat", element: WalletFiat },
      { path: "/wallets-crypto", element: WalletCrypto },

      { path: "/utilities", element: Utilities },
      { path: "/transactions", element: Transactions },
      { path: "/settings", element: Settings },
      { path: "/rates", element: Rates },
      { path: "/success-trade", element: SuccessTransaction },
      { path: "/download-app", element: DownloadApp },
      { path: "/notifications", element: Notifications },

      // { path: '/wallet/withdraw', element: WithdrawNaira },
    ].map((r, ind) => (
      <Route
        key={ind}
        exact
        path={r.path}
        element={
          <UserIsAuthenticated>
            <r.element />
          </UserIsAuthenticated>
        }
      />
    ))}
  </Route>
);

export default PrivateRoutes;
